<template>
    <task-delivery-instagram-story-provider
        v-slot="{
            campaign,
            contact,
            proposal,
            task,
            job,
            errorMessage,
            isLoading,
            deliverStoryUrl,
            deliverInsightsUrl,
            uploadHeaders,
            isJobDelivered,
            handleInsightsFileChange,
            handleStoryFileChange,
            jobHasInsights,
            handleStartConnection,
            hasUploadedFiles,
            uploadedFiles,
            handleReloadProposal
        }"
        style="height: 100%"
    >
        <task-delivery-instagram-story-view
            :campaign="campaign"
            :contact="contact"
            :proposal="proposal"
            :task="task"
            :job="job"
            :is-loading="isLoading"
            :error-message="errorMessage"
            :deliver-story-url="deliverStoryUrl"
            :deliver-insights-url="deliverInsightsUrl"
            :upload-headers="uploadHeaders"
            :is-job-delivered="isJobDelivered"
            :job-has-insights="jobHasInsights"
            :has-uploaded-files="hasUploadedFiles"
            :uploaded-files="uploadedFiles"
            @story-file-change="handleStoryFileChange"
            @insights-file-change="handleInsightsFileChange"
            @start-connection="handleStartConnection"
            @reload-proposal="handleReloadProposal"
        />
    </task-delivery-instagram-story-provider>
</template>

<script>
    import TaskDeliveryInstagramStoryProvider from '../providers/TaskDeliveryInstagramStoryProvider.vue';
    import TaskDeliveryInstagramStoryView from '../data-views/proposals/TaskDeliveryInstagramStoryView.vue';

    export default {
        name: 'TaskDeliveryInstagramStoryRouterView',
        components: {
            TaskDeliveryInstagramStoryView,
            TaskDeliveryInstagramStoryProvider
        }
    };
</script>
